import http from "../../../service/axios";
import { INotificationDto, INotificationsPage } from "../types/Notification";

type Envelope<T> = { success: boolean; data: T };

// JSON явно: перехватчик axios подставляет multipart всему без Content-Type.
const json = { headers: { "Content-Type": "application/json" } };

/** Центр уведомлений: история пушей Mindbox, сохранённых бэкендом. */
export const notificationAPI = {
  getPage: async (page: number, perPage: number) =>
    await http.get<Envelope<INotificationsPage>>("/notification", {
      params: { page, per_page: perPage },
    }),
  markRead: async (id: number) =>
    await http.post<Envelope<{ item: INotificationDto }>>(
      "/notification/read",
      { id },
      json,
    ),
  getUnreadCount: async () =>
    await http.get<Envelope<{ count: number }>>("/notification/unread-count"),
};
